<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>二维码管理</h6>
    
      <el-button class="titBtn" type="success" icon="el-icon-search" @click="search">搜索</el-button>

      <addressTree @obj="objdata" @close="treeClose"></addressTree>
    </div>

    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange"
        :header-cell-style="{background:'rgba(49,130,222,0.1)'}" :data="tabledata" :height="tableHeight" border>
        <!--
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" align='center' width="45" label="序号"></el-table-column>
        -->
        <el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
        <el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
        <el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
        <el-table-column prop="ydbXiang" width="180" align='center' label="乡"></el-table-column>
        <el-table-column prop="ydbCun" width="150" align='center' label="村"></el-table-column>
        <el-table-column prop="ydbName" width="200" align='center' label="坝名"></el-table-column>
        <el-table-column prop="ydbCode" width="200" align='center' label="编码"></el-table-column>
        <el-table-column width="200" align='center' label="二维码">
            <template slot-scope="scope">
                <el-button @click="handleCheck(scope.row)" size="small" type="text">查看</el-button>
                <a class="down-qr" :href="scope.row.ydbqrcodebase64" download="qrCode">下载</a>
                
            </template>
        </el-table-column>
        
      </el-table>

    </div>
    <div class="fye">
      <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums"></pagintion>
    </div>

  </div>
</template>

<script>
  import addressTree from '@/components/mangement/addressTree.vue';
  import pagintion from '@/components/mangement/pagintion.vue';

//   import Url from '@/common/js/Url.js';
  import axios from "axios";
  import {
    selectYdbInfo,
    ydbdeleteYdbInfo,
    selectYdbQrcodeInfo,
    getQrcodeInfo
  } from '@/api/api.js'
  export default {
    data() {
      return {
        tableHeight: window.innerHeight - 180,
        tabledata: [],
        defaultProps: {
          children: 'child',
          label: 'name',
        },
        total: null,
        pageSize: 20, //每页多少条数据分页
        pageNum: 1, //当前页
        pageNums: null,
        multipleSelection: [],
        // dialogVisible: false,
        // Addsid: [],
        objdata1: null,
        imgUrlBase64: '' //保存返回的base64位的二维码
        
      }

    },

    components: {
      addressTree,
      pagintion
    },
    mounted() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)

      // // 拿到表格挂载后的真实DOM
      // const table = this.$refs.multipleTable;
      // // 拿到表格中承载数据的div元素
      // const divData = table.bodyWrapper;
      // // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      // setInterval(() => {
      //   // 元素自增距离顶部1像素
      //   divData.scrollTop += 2;
      //   // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
      //   if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
      //     // 重置table距离顶部距离
      //     divData.scrollTop = 0;
      //   }
      // }, 50);
    },
    methods: {
      
    //   点击查看二维码
    handleCheck(row){
            this.imgUrlBase64 = row.ydbqrcodebase64;
            // 获取列表数据中的base64的二维码数据
            this.$alert(`<img src="${this.imgUrlBase64}" width='390' height='400'>`, '大坝信息', {
                dangerouslyUseHTMLString: true,
                showClose: true,
                showConfirmButton: false,
                closeOnClickModal: true
            });
    },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
     
      treeClose() {
        this.objdata1 = null;
        this.total = null;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1
        }
        this.list(params)
      },
      search() {
        this.tabledata = [];
        this.total = null;
        this.pageSize = 20;
        this.pageNum = 1;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1
        };
        this.list(params)
      },

      objdata(data) {
        this.objdata1 = data;
      },
      DsyData(data) { //多少页
        this.pageNum = data.dsy;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1
        }
        this.list(params)
      },
      DstData(data) { //多少条
        this.pageSize = data.dst;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1
        }
        this.list(params)
      },

      list(params) {
        this.tabledata = [];
        selectYdbQrcodeInfo(params).then((res) => {
          // console.log(res)
          this.total = res.total;
          this.tabledata = res.data;
        })
      },

    }
  }
</script>

<style scoped>
  @import url('../../../common/css/mangementall.css');

  .zblxtree {
    width: 230px;
    height: calc(100% - 80px);
    height: -webkit-calc(100% - 80px);
    height: -moz-calc(100% - 80px);
    background: #f7f7f7;
    border-radius: 6px;
    float: left;
    overflow: auto;
    padding: 15px;
  }

  .zblxtreeSty {
    background: #f7f7f7;
    border-radius: 6px;
  }

  .tablelist {
    width: 100%;
    height: calc(100% - 50px);
    height: -webkit-calc(100% - 50px);
    height: -moz-calc(100% - 50px);
    float: right;
    position: relative;
  }

  .tablelistbox {
    width: 100%;
    heigt: 100%;
  }

  .clsjTis {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    width: 335px;
    height: 210px;
    border: 1px solid #cccccc;
    background: #f7f7f7;
    border-radius: 6px;
    font-size: 16px;
  }

  .ycllxname {
    float: left;
    line-height: 30px;
    font-size: 14px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .cllx-select {
    float: left;
    margin-top: 10px;
    width: 230px;
  }

  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .zzct {
    font-size: 20px;
    margin-right: 10px;
  }

  .import-s {
    float: right;
    position: relative;
    width: 100px;
    height: 28px;
    background: #409eff;
    margin-right: 10px;
    border-radius: 4px;
    margin-top: 11px;
    overflow: hidden;
  }

  .import-s p {
    position: absolute;
    width: 100%;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
  }

  .import-s p span {
    margin-right: 5px;
  }

  .import-s input {
    width: 100%;
    height: 28px;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  >>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;

    font-size: 14px;
  }

  .down-qr{
    color: #409EFF;
    padding: 12px 20px;
    border-radius: 4px;
    margin: 0;
    box-sizing: border-box;
  }
  .down-qr:hover{
    text-decoration: none;
  }
</style>
